import React from 'react';
import './button.sass';

export const ButtonType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TRANSPARENT: 'transparent',
  TRANSPARENT_BORDER: 'transparent-border',
  YELLOW: 'yellow',
  BLACK: 'black'
};

export const ButtonSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  BIG: 'big',
  LANDING: 'landing-page',
  VENDOR: 'vendor',
  NO_PADDING: 'no-padding',
};

export const Button = ({text, buttonType = ButtonType.PRIMARY, size = ButtonSize.MEDIUM, color, type, onClick, iconLeft, iconRight, disabled}) => {
  return (
    <button className={`vv-button vv-button--${buttonType} vv-button--${size} ${disabled ? 'vv-button--disabled' : ''}`} type={type} style={{color}} onClick={onClick} disabled={disabled}>
      {iconLeft ? <img className='vv-button__margin-right' src={iconLeft} alt='icon left'/> : null}
      {text}
      {iconRight ? <img className='vv-button__margin-left' src={iconRight} alt='icon right'/> : null}
    </button>
  );
};
